import { createPromiseAction, createFetchAction } from '../../utils';

export const devicesSyntaxAvailabilityAction = {
  ...createFetchAction('deviceSyntaxAvailability'),
};

export const fetchDeviceSyntaxAvailability = createPromiseAction(
  'dvm/FETCH_DEVICE_SYNTAX_AVAILABILITY'
);
